import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgBarsMaximizeRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "m9.725 11.344-5.99-6.046a1.043 1.043 0 0 0-1.42-.037.92.92 0 0 0-.04 1.348L7.65 12l-5.374 5.39a.92.92 0 0 0 .039 1.35 1.044 1.044 0 0 0 1.42-.036l5.99-6.046A.93.93 0 0 0 10 12a.93.93 0 0 0-.275-.657M21 18a1 1 0 1 0 0-2H11a1 1 0 1 0 0 2zm0-5a1 1 0 1 0 0-2h-7a1 1 0 1 0 0 2zm1-6a1 1 0 0 0-1-1H11a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1"
    }));
export default SvgBarsMaximizeRegular;
